import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$defaulthisepbk9rprr as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from './Decoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractDecoderClass;
function AbstractDecoder() {
  if (AbstractDecoderClass === VOID) {
    class $ {
      decodeValue_jl9esj_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      decodeNotNullMark_us4ba1_k$() {
        return true;
      }
      decodeNull_jzrmuj_k$() {
        return null;
      }
      decodeBoolean_m0aca_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      decodeByte_jzz7je_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeShort_jjqk32_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeInt_8iq8f5_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeLong_jzt186_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      decodeFloat_jcnrwu_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeDouble_ur8l0f_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeChar_dcmcfa_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return tmp instanceof Char() ? tmp.value_1 : THROW_CCE();
      }
      decodeString_x3hxsx_k$() {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        var tmp = this.decodeValue_jl9esj_k$();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      decodeInline_ux3vza_k$(descriptor) {
        return this;
      }
      decodeSerializableValue_8i9jjz_k$(deserializer, previousValue) {
        return this.decodeSerializableValue_xpnpad_k$(deserializer);
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
      decodeBooleanElement_vuyhtj_k$(descriptor, index) {
        return this.decodeBoolean_m0aca_k$();
      }
      decodeByteElement_c1pisz_k$(descriptor, index) {
        return this.decodeByte_jzz7je_k$();
      }
      decodeShortElement_pzg12t_k$(descriptor, index) {
        return this.decodeShort_jjqk32_k$();
      }
      decodeIntElement_941u6a_k$(descriptor, index) {
        return this.decodeInt_8iq8f5_k$();
      }
      decodeLongElement_994anb_k$(descriptor, index) {
        return this.decodeLong_jzt186_k$();
      }
      decodeFloatElement_p2q55h_k$(descriptor, index) {
        return this.decodeFloat_jcnrwu_k$();
      }
      decodeDoubleElement_isei84_k$(descriptor, index) {
        return this.decodeDouble_ur8l0f_k$();
      }
      decodeCharElement_frbao3_k$(descriptor, index) {
        return this.decodeChar_dcmcfa_k$();
      }
      decodeStringElement_3oenpg_k$(descriptor, index) {
        return this.decodeString_x3hxsx_k$();
      }
      decodeInlineElement_s8883o_k$(descriptor, index) {
        return this.decodeInline_ux3vza_k$(descriptor.getElementDescriptor_ncda77_k$(index));
      }
      decodeSerializableElement_uahnnv_k$(descriptor, index, deserializer, previousValue) {
        return this.decodeSerializableValue_8i9jjz_k$(deserializer, previousValue);
      }
      decodeNullableSerializableElement_k2y6ab_k$(descriptor, index, deserializer, previousValue) {
        // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
        var isNullabilitySupported = deserializer.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$();
        var tmp;
        if (isNullabilitySupported || this.decodeNotNullMark_us4ba1_k$()) {
          tmp = this.decodeSerializableValue_8i9jjz_k$(deserializer, previousValue);
        } else {
          tmp = this.decodeNull_jzrmuj_k$();
        }
        return tmp;
      }
    }
    protoOf($).decodeSerializableElement$default_j0zaoi_k$ = decodeSerializableElement$default;
    protoOf($).decodeSerializableValue_xpnpad_k$ = decodeSerializableValue;
    protoOf($).decodeSequentially_xlblqy_k$ = decodeSequentially;
    protoOf($).decodeCollectionSize_l3mlkk_k$ = decodeCollectionSize;
    initMetadataForClass($, 'AbstractDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    AbstractDecoderClass = $;
  }
  return AbstractDecoderClass;
}
//region block: exports
export {
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
};
//endregion

//# sourceMappingURL=AbstractDecoder.mjs.map
